<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="4" md="4">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataAskingPrice" 
                            label="Asking Price"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="editData.anticipated_close_date"
                                    label="Anticipated Close Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="editData.anticipated_close_date"
                                @input="menu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="4" md="4">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.cash_down"
                            label="Cash Down"
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.consulting_timeline"
                            label="Consulting Timeline">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="4" md="4">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.escrow"
                            label="Escrow"
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="d-column pl-12">
                        <div class="d-block">
                            <v-switch 
                                :input-value="dataBusinessDevelopment" 
                                color="accent"
                                :label="`Business Development: ${dataBusinessDevelopment == true ? 'Yes':'No'}`"
                                @change="toggleBusinessDevelopmentFlag($event)">
                            </v-switch>
                        </div>
                        <div class="d-block">
                            <v-switch 
                                :input-value="dataPostTransition" 
                                color="accent" 
                                :label="`Post Transition: ${dataPostTransition == true ? 'Yes':'No'}`"
                                @change="togglePostTransitionFlag($event)">
                            </v-switch>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'

    export default {
        name: 'PriceAndTerms',
        props: [
            'editData'
        ],
        data: () => ({
            menu: false,
        }),
        
        computed: {
            dataAskingPrice: {
                get: function() {
                    return this.editData.asking_price != null ? formatNumbers(scrubNumbers(this.editData.asking_price)) : ''
                },
                set: function(val) {
                    this.swapNumbers('asking_price', val);
                    return val;
                }
            },

            dataBusinessDevelopment: {
                get: function() {
                    return this.editData.business_development
                },
                set: function(val) {
                    return val
                }
            },
            
            dataPostTransition: {
                get: function() {
                    return this.editData.post_transition
                },
                set: function(val) {
                    return val
                }
            }
        },

        methods: {
            swapNumbers: function (field, val) {
                this.editData[field] = scrubNumbers(val);
            },

            toggleBusinessDevelopmentFlag: function (toggle_bd) {
                this.editData.business_development = toggle_bd
            },

            togglePostTransitionFlag: function (toggle_pt) {
                this.editData.post_transition = toggle_pt
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/PriceAndTerms.vue